module.exports = __webpack_public_path__ + "media/slot-game/gift-outlined-8a834cb4.svg";